import { AiDetailedFeedback, AiFeedbackTypes, AiNegativeFeedback } from './types';

/** Whether the given feedback is a negative feedback. */
export const isNegativeAiFeedback = (feedback: AiDetailedFeedback): feedback is AiNegativeFeedback =>
    feedback.type === AiFeedbackTypes.DISLIKED;
